import { AuthClient } from "../data/auth-client";

async function Register(
  nombre_completo,
  email,
  telefono,
  contrasena,
  rol,
  codelec,
  junta
) {
  try {
    const authClient = new AuthClient();
    await authClient.register({
      nombre_completo,
      email,
      telefono,
      contrasena,
      rol,
      codelec,
      junta,
    });
  } catch (err) {
    console.error("Register error", err);
    throw new Error("Register error");
  }
}

export default Register;
